export const queryKeys = {
  GET_ME: "getMe",
  GET_ALBUMS: "getAlbums",
  GET_ALBUM_DETAIL: "getAlbumDetail",
  GET_ALBUM_DETAIL_ANO: "getAlbumDetailAno",
  GET_MEMBERSHIP_PLANS: "getMembershipPlans",
  GET_DISCOUNT: "getDiscount",
  GET_STATIC_PAGE: "getStaticPage",
  GET_UPGRADE: "getUpgrade",
  GET_CALCULATE_UPGRADE: "getCalculateUpgrade",
  GET_ALBUM_SYNC: "getAlbumSync",
  GET_ALBUM_BASIC: "getAlbumBasic",
  GET_ALBUM_PUBLIC: "getAlbumPublic",
  GET_WEBSITE: "getWebsite",
  CHECK_DRIVE_COPY: "checkDriveCopy",
  GET_NOTIFICATION: "getNotification",
  GET_REFERRAL_DASHBOARD: "getReferralDashboard",
  GET_REFERRAL_CODE: "getReferralCode",
  GET_REFERRAL_HISTORY: "getReferralHistory",
  GET_ACTIVE_REWARDS: "getActiveRewards",
};
